import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { SpinWheelFilterEntity } from '../../domain/entities/SpinWheelFilterEntity'

export class SpinWheelFilterModel extends SpinWheelFilterEntity {
  constructor(dataDto: SpinWheelFilterEntity) {
    super()
    mapEntityProperties<SpinWheelFilterModel>(this, dataDto)
  }
}
